 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-en":"lang-en","lang-es":"lang-es","lang-pt":"lang-pt","lang-zh-CN":"lang-zh-CN"}[chunkId]||chunkId) + "." + {"chunk-06832135":"f46bf599","chunk-2092e924":"daea852c","chunk-265d421a":"e8437468","chunk-2862f762":"eb13da01","chunk-550902a2":"e52eaee9","chunk-a5eb763a":"41c56869","chunk-2d0b6ad6":"a582a915","chunk-2d0c96f9":"608b2a11","chunk-2f3844e8":"97940f86","chunk-d90690bc":"1595dc05","chunk-30e2b601":"2d69be8d","chunk-37306bcc":"4a12b44f","chunk-390136ce":"f024adc3","chunk-87cf18ce":"b6b875fc","chunk-7def7144":"4b7946cd","chunk-fa68604a":"f76c2b5c","chunk-401d0265":"6ed81611","chunk-45813ada":"a41d0883","chunk-45e560ba":"bc33187d","chunk-4b1c96c8":"0e37c34c","chunk-1bd51f3a":"6d329ec3","chunk-241ee77a":"7f12bcce","chunk-4f374db4":"3f6c9c83","chunk-adffcf24":"7f47e1b3","chunk-50be1f06":"091555b4","chunk-530085f2":"d18cf2a6","chunk-5529b5e4":"83c3c053","chunk-563416de":"1211623c","chunk-5789bcdc":"c9118080","chunk-583a0834":"049aa3e8","chunk-59518984":"1a2d4d31","chunk-5fef911c":"b6baf585","chunk-619e517c":"05855290","chunk-0b3fc655":"6dac9b55","chunk-0ea6fb50":"d7361b6a","chunk-2a50ef36":"af2243c7","chunk-da271c84":"aa930e85","chunk-0eebc0b6":"beb17f06","chunk-1c96cd9e":"073e18c6","chunk-2a2733a6":"fd916bd8","chunk-2bd61530":"50dd3bf6","chunk-69e13543":"79a60e5c","chunk-fb49fe10":"fc2c7bbe","chunk-365042c7":"89ec3b37","chunk-63f06dde":"2579cf99","chunk-71cf1dd4":"f2123200","chunk-6831a6c1":"13589cf0","chunk-2845b666":"af9c402f","chunk-0bd846aa":"c3b4da54","chunk-2f3cd83c":"5164fb1c","chunk-3569009e":"7d28f02f","chunk-3f2285b0":"804a78cf","chunk-48f6a226":"db961aef","chunk-6f86f278":"418b6830","chunk-7a43c806":"4d0e3944","chunk-7e45079f":"d20879f3","chunk-83636332":"fa1f8bd6","chunk-8679801a":"d6382f24","chunk-98fdc822":"0c519b71","chunk-e4d987fe":"2fb7bb3e","chunk-3808b6b4":"49eef608","chunk-1240ffb5":"30cc890d","chunk-3feffc5f":"fdcc109d","chunk-5b31b18a":"2ad7247a","chunk-6fa93d69":"4ad34105","chunk-b2608ea0":"e618033c","chunk-1ed227df":"bf676fde","chunk-165c8cc4":"9cf7cdaa","chunk-2fd763e4":"2ae4c68c","chunk-13ac409c":"8d9c86e5","chunk-3dcb617f":"f09fc314","chunk-4a8510d8":"4b95cc84","chunk-d3d4b1e4":"f031211f","chunk-4ba7540c":"6fd3bbca","chunk-4e1b6bd8":"1c79df2f","chunk-12ee9e0a":"ef0f9be4","chunk-562f95a1":"7f58dec8","chunk-5c9f1016":"eb741bcd","chunk-cfc767c4":"9dbd7a4f","chunk-70c75b3e":"e0eb2313","chunk-75f68215":"175178dc","chunk-ee240342":"a0b4d7a6","chunk-efebbd72":"82a9e34b","chunk-4aa9fdc2":"3faefd9f","chunk-53ad5351":"1253bb06","chunk-f4d7fc4c":"eb4c3187","chunk-70ab06d9":"16f6d783","chunk-657c56c1":"f7f1d11f","chunk-1d42d0cd":"884b1678","chunk-69ef3cbc":"7ddeb980","chunk-6f08bde0":"3ca1c53d","chunk-72f8287c":"e980f048","chunk-74de98a0":"6572a427","chunk-466ae960":"6aaf2b86","chunk-752e2a9c":"ec5f9ca0","chunk-7af3d49b":"b6ca8d37","chunk-7c039a8c":"f1e40b97","chunk-7fc198b3":"4faf2b25","chunk-8369b7e4":"741df513","chunk-8b4969c2":"5528a398","chunk-96a4c278":"8e985378","chunk-a4d42a1e":"fd75aa79","chunk-afacc7da":"1f404843","chunk-bdb3f636":"6e48c493","chunk-bfa6fe80":"5010a125","chunk-c54236cc":"7d012b99","chunk-d3f3acb8":"bf2200c4","chunk-0ebf5180":"c4edaf33","chunk-3cd4b108":"c3fb15b3","chunk-7a26038b":"d58ab8f6","chunk-42cc720a":"0e9890b8","chunk-7d560b86":"6b66830f","chunk-c1452c00":"4d132942","chunk-d7a488de":"14abb3eb","chunk-f11a9108":"e0ba2d9d","chunk-1a0377ae":"9e144b28","chunk-fac408a0":"c4252eb6","lang-en":"e7848d63","lang-es":"42c595d2","lang-pt":"b8fbc35f","lang-zh-CN":"f4eec157","chunk-8f02821a":"39930d77","chunk-0d5420af":"4a179dcf","chunk-34abee0c":"745886ea","chunk-b5f62efe":"5d7733f1","chunk-2652bea4":"3db1b757","chunk-49140c10":"bed8bc1c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-06832135":1,"chunk-2092e924":1,"chunk-265d421a":1,"chunk-2862f762":1,"chunk-2f3844e8":1,"chunk-d90690bc":1,"chunk-30e2b601":1,"chunk-37306bcc":1,"chunk-390136ce":1,"chunk-87cf18ce":1,"chunk-7def7144":1,"chunk-fa68604a":1,"chunk-401d0265":1,"chunk-45813ada":1,"chunk-45e560ba":1,"chunk-4b1c96c8":1,"chunk-1bd51f3a":1,"chunk-241ee77a":1,"chunk-4f374db4":1,"chunk-adffcf24":1,"chunk-50be1f06":1,"chunk-530085f2":1,"chunk-5529b5e4":1,"chunk-563416de":1,"chunk-5789bcdc":1,"chunk-583a0834":1,"chunk-59518984":1,"chunk-5fef911c":1,"chunk-619e517c":1,"chunk-0b3fc655":1,"chunk-0ea6fb50":1,"chunk-2a50ef36":1,"chunk-da271c84":1,"chunk-0eebc0b6":1,"chunk-1c96cd9e":1,"chunk-2a2733a6":1,"chunk-2bd61530":1,"chunk-69e13543":1,"chunk-fb49fe10":1,"chunk-365042c7":1,"chunk-63f06dde":1,"chunk-71cf1dd4":1,"chunk-6831a6c1":1,"chunk-2845b666":1,"chunk-0bd846aa":1,"chunk-2f3cd83c":1,"chunk-3569009e":1,"chunk-3f2285b0":1,"chunk-48f6a226":1,"chunk-6f86f278":1,"chunk-7a43c806":1,"chunk-7e45079f":1,"chunk-83636332":1,"chunk-8679801a":1,"chunk-98fdc822":1,"chunk-e4d987fe":1,"chunk-3808b6b4":1,"chunk-1240ffb5":1,"chunk-3feffc5f":1,"chunk-5b31b18a":1,"chunk-6fa93d69":1,"chunk-b2608ea0":1,"chunk-1ed227df":1,"chunk-165c8cc4":1,"chunk-2fd763e4":1,"chunk-13ac409c":1,"chunk-3dcb617f":1,"chunk-4a8510d8":1,"chunk-d3d4b1e4":1,"chunk-4ba7540c":1,"chunk-4e1b6bd8":1,"chunk-12ee9e0a":1,"chunk-562f95a1":1,"chunk-5c9f1016":1,"chunk-cfc767c4":1,"chunk-70c75b3e":1,"chunk-75f68215":1,"chunk-ee240342":1,"chunk-efebbd72":1,"chunk-4aa9fdc2":1,"chunk-53ad5351":1,"chunk-f4d7fc4c":1,"chunk-70ab06d9":1,"chunk-657c56c1":1,"chunk-1d42d0cd":1,"chunk-69ef3cbc":1,"chunk-6f08bde0":1,"chunk-72f8287c":1,"chunk-74de98a0":1,"chunk-466ae960":1,"chunk-752e2a9c":1,"chunk-7af3d49b":1,"chunk-7c039a8c":1,"chunk-7fc198b3":1,"chunk-8369b7e4":1,"chunk-8b4969c2":1,"chunk-96a4c278":1,"chunk-a4d42a1e":1,"chunk-afacc7da":1,"chunk-bdb3f636":1,"chunk-bfa6fe80":1,"chunk-c54236cc":1,"chunk-d3f3acb8":1,"chunk-0ebf5180":1,"chunk-3cd4b108":1,"chunk-7a26038b":1,"chunk-42cc720a":1,"chunk-7d560b86":1,"chunk-c1452c00":1,"chunk-d7a488de":1,"chunk-f11a9108":1,"chunk-1a0377ae":1,"chunk-fac408a0":1,"chunk-8f02821a":1,"chunk-0d5420af":1,"chunk-34abee0c":1,"chunk-b5f62efe":1,"chunk-2652bea4":1,"chunk-49140c10":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-en":"lang-en","lang-es":"lang-es","lang-pt":"lang-pt","lang-zh-CN":"lang-zh-CN"}[chunkId]||chunkId) + "." + {"chunk-06832135":"68203507","chunk-2092e924":"d571f524","chunk-265d421a":"9e9b21f8","chunk-2862f762":"24da8235","chunk-550902a2":"31d6cfe0","chunk-a5eb763a":"31d6cfe0","chunk-2d0b6ad6":"31d6cfe0","chunk-2d0c96f9":"31d6cfe0","chunk-2f3844e8":"cad4b3b8","chunk-d90690bc":"7b40dc8c","chunk-30e2b601":"2cefb08b","chunk-37306bcc":"37de909b","chunk-390136ce":"20f4b591","chunk-87cf18ce":"3dfcd5c3","chunk-7def7144":"be2a431b","chunk-fa68604a":"aa563f35","chunk-401d0265":"a85ea77a","chunk-45813ada":"46917cb5","chunk-45e560ba":"4d14e3f2","chunk-4b1c96c8":"251aff79","chunk-1bd51f3a":"19f57f3f","chunk-241ee77a":"e314f6ea","chunk-4f374db4":"d9b4e4b0","chunk-adffcf24":"dd8bc02e","chunk-50be1f06":"96c680f4","chunk-530085f2":"8482f249","chunk-5529b5e4":"31af8ba7","chunk-563416de":"a4a0fd5f","chunk-5789bcdc":"7a1f96b3","chunk-583a0834":"7a2cdb23","chunk-59518984":"a09c889b","chunk-5fef911c":"92a3651a","chunk-619e517c":"f9fdb384","chunk-0b3fc655":"100c8a28","chunk-0ea6fb50":"e441937a","chunk-2a50ef36":"7944af09","chunk-da271c84":"87f2967e","chunk-0eebc0b6":"b074317d","chunk-1c96cd9e":"e3350f8d","chunk-2a2733a6":"b834b88e","chunk-2bd61530":"10afa31d","chunk-69e13543":"f4628f0e","chunk-fb49fe10":"c76ee962","chunk-365042c7":"4e5b88be","chunk-63f06dde":"aed27705","chunk-71cf1dd4":"a1f67bb6","chunk-6831a6c1":"0def483c","chunk-2845b666":"f8034f2c","chunk-0bd846aa":"afbaba1f","chunk-2f3cd83c":"96e56b0b","chunk-3569009e":"0a48e4b6","chunk-3f2285b0":"4c4efcda","chunk-48f6a226":"57582277","chunk-6f86f278":"f2425f01","chunk-7a43c806":"d4fbcde0","chunk-7e45079f":"0f40fbde","chunk-83636332":"0f8f5ec3","chunk-8679801a":"cdf2db6b","chunk-98fdc822":"393cb613","chunk-e4d987fe":"fac3865b","chunk-3808b6b4":"5dc85e78","chunk-1240ffb5":"f84183bf","chunk-3feffc5f":"247d39dd","chunk-5b31b18a":"167b29ca","chunk-6fa93d69":"89fd5e0a","chunk-b2608ea0":"e31c08f8","chunk-1ed227df":"4de5b5d5","chunk-165c8cc4":"70ea3894","chunk-2fd763e4":"943e3bec","chunk-13ac409c":"09ddd1bc","chunk-3dcb617f":"21dad724","chunk-4a8510d8":"7ab7fe90","chunk-d3d4b1e4":"da036708","chunk-4ba7540c":"91810b4c","chunk-4e1b6bd8":"c8109b24","chunk-12ee9e0a":"91779ddc","chunk-562f95a1":"414a353c","chunk-5c9f1016":"c7bae9ae","chunk-cfc767c4":"0b03d687","chunk-70c75b3e":"15c519f2","chunk-75f68215":"e7a48a23","chunk-ee240342":"e2880ab9","chunk-efebbd72":"2ef4161a","chunk-4aa9fdc2":"79483768","chunk-53ad5351":"eeb87b89","chunk-f4d7fc4c":"03893ee8","chunk-70ab06d9":"980a2197","chunk-657c56c1":"3cb404f6","chunk-1d42d0cd":"673ad3bf","chunk-69ef3cbc":"dd201c2e","chunk-6f08bde0":"76afd7c7","chunk-72f8287c":"1e20953a","chunk-74de98a0":"5767cc8a","chunk-466ae960":"9847677c","chunk-752e2a9c":"a75891c4","chunk-7af3d49b":"3481e631","chunk-7c039a8c":"065c8d7b","chunk-7fc198b3":"c2be7b91","chunk-8369b7e4":"867c99c3","chunk-8b4969c2":"12789c67","chunk-96a4c278":"f2f64075","chunk-a4d42a1e":"a2d07b58","chunk-afacc7da":"ff218d41","chunk-bdb3f636":"08f4a06b","chunk-bfa6fe80":"58b47bd4","chunk-c54236cc":"c2f6a27f","chunk-d3f3acb8":"8a1752fa","chunk-0ebf5180":"5105b6db","chunk-3cd4b108":"5105b6db","chunk-7a26038b":"6a75abe1","chunk-42cc720a":"c890a5ee","chunk-7d560b86":"54d250cb","chunk-c1452c00":"b8fb06b5","chunk-d7a488de":"b7b640c7","chunk-f11a9108":"3651ab7b","chunk-1a0377ae":"56c875d9","chunk-fac408a0":"ef8ae85f","lang-en":"31d6cfe0","lang-es":"31d6cfe0","lang-pt":"31d6cfe0","lang-zh-CN":"31d6cfe0","chunk-8f02821a":"48e3ff27","chunk-0d5420af":"523e3cad","chunk-34abee0c":"cb0fed8a","chunk-b5f62efe":"f61af3cd","chunk-2652bea4":"f36bd067","chunk-49140c10":"c6950b21"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
